module.exports = __webpack_public_path__ + "2f8663a6ec9387772ae0a0bfde5a0607.glb";